<template>
  <div class="go-uranaitv-base" :style="styles">
    <h3 class="go-uranaitv-base__point-copy" v-html="upperCaption"></h3>
    <div class="btn-wrap">
      <lp-base-button
        :label="buttonFace"
        design="fill"
        :color-scheme="colorScheme"
        class="block-uranaitv-base__point-btn"
        @clicked="onClick"
      />
    </div>
    <div class="go-uranaitv-base__lower-copy" v-html="lowerCaption" v-if="lowerCaption.length > 0"></div>
  </div>
</template>

<script>
import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton'

export default {
  name: 'GoUranaiTv',
  components: {
    LpBaseButton,
  },
  props: {
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    gaEventCateg: {
      type: String,
      default: ''
    },
    gaEventLabel: {
      type: String,
      default: ''
    },
    subscUrl: {
      type: String,
      default: '/'
    },
    menuId: {
      type: Number,
      default: 1,
    },
    upperCaption: {
      type: String,
      default: '占いTV<br>月額528円（税込）'
    },
    buttonFace: {
      type: String,
      default: '登録して占う'
    },
    lowerCaption: {
      type: String,
      default: ''
    }
  },
  methods: {
    onClick(){
      window.gtag('event', 'click', {
        'event_category': this.gaEventCateg,
        'event_label': this.gaEventLabel,
      })
      location.href = this.$handoverParams(this.subscUrl)
    },
  },
  computed: {
    styles() {
      return {
        '--key-color': this.colorScheme.keyColor,
      }
    }
  }
}
</script>

<style scoped lang="scss">
$l_col_keycolor: var(--key-color);
.go-uranaitv-base {
  width: 100%;
  max-width: 580px;
  margin: 0 auto;
  h3 {
    font-weight: bold;
    font-size: 26px;
    line-height: 32px;
    text-align: center;
    margin: 0 0 20px;
    color: $l_col_keycolor;
  }
  &__lower-copy {
    font-size: 14px;
    line-height: 21px;
    text-align: center;
    margin: 20px 0 0;
    color: #32373F;
  }
  .btn-wrap {
    width: 100%;
    max-width: 270px;
    margin: auto;
  }
}

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/partials/GoUranaiTv.vue